<template>
  <section class="bg">
    <section class="market">
      <index-market
        class="index_market"
        :indexMarket="indexMarket"
      ></index-market>
      <market-range class="market-range"></market-range>
      <hot-range
        class="hot_range"
        :hotRange="hotRange"
      ></hot-range>
      <section class="info_layout">
        <hk-change
          class="info"
          :hkChange="hkChange"
        ></hk-change>
        <com-info
          class="info"
          :companyInfo="companyInfo"
        ></com-info>
        <announcement
          class="info"
          :companySum="companySum"
        ></announcement>
      </section>
    </section>
  </section>
</template>

<script>
import * as api from "~/api/index";
import indexMarket from "~/components/market/index-market";
import marketRange from "~/components/market/market-range";
import hotRange from "~/components/market/hot-range";
import hkChange from "~/components/market/hk-change";
import comInfo from "~/components/market/company-info";
import announcement from "~/components/market/announcement";
export default {
  components: {
    indexMarket,
    marketRange,
    hotRange,
    hkChange,
    comInfo,
    announcement
  },
  async asyncData({ route, error, app, $axios }) {
    try {

      let [indexMarket, hotRange, hkChange, companySum, companyInfo] = await Promise.all([
        $axios(api.getIndexMarket()),
        $axios(api.getHotRange()),
        $axios(api.getHKChange()),
        $axios(api.getCompanySum()),
        $axios(api.getCompanyInfo())
      ]);
      return {
        indexMarket:
          indexMarket && indexMarket.result ? indexMarket.result : [],
        hotRange: hotRange && hotRange.details
          ? hotRange.details
          : { attention: [], discuss: [], transaction: [] },
        hkChange: hkChange && hkChange.result ? hkChange.result : [],
        companySum: companySum && companySum.result ? companySum.result : [],
        companyInfo: companyInfo && companyInfo.result ? companyInfo.result : []
      };
    } catch (err) {
      console.log(err);
      error({
        statusCode: 404,
        message: "Post not Found"
      });
    }
  },
  methods: {},
  head() {
    return {
      title: '专家荐股_中概股名单_网红概念股股票-格隆汇',
      meta: [
        {
          hid: "description",
          name: "description",
          content: '格隆汇行情栏目想针对专家荐股,中概股名单、港股涨跌幅、成交额、成交量等作出了详细的介绍,格隆汇已成为国内权威的海外（尤其港股）投资研究交流平台.'
        },
        {
          hid: "keywords",
          name: "keywords",
          content: '专家荐股,中概股名单,网红概念股股票'
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.bg {
  background-color: #fff;
  // border-top: 1px solid #f1f3f7;
}
.market {
  margin: 0 auto;
  width: 1200px;
}
.index_market {
  padding-top: 31px;
  padding-bottom: 52px;
}
.market-range {
  margin-bottom: 52px;
}
.hot_range {
  margin-bottom: 52px;
}
.info_layout {
  padding-bottom: 40px;
}
.info {
  width: 360px;
  display: inline-block;
  margin-bottom: 77px;
}
.info:not(:first-child) {
  margin-left: 55px;
}
</style>

